const xhrGetHeaders = (xhr) => {
  const headers = {};
  const headerString = xhr.getAllResponseHeaders();
  const headerEntries = headerString.trim().split(/[\r\n]+/);
  headerEntries.forEach((header) => {
    const parts = header.split(": ");
    const headerName = parts[0].trim().toLowerCase();
    const headerValue = parts[1].trim();
    if (headerName && headerValue) {
      headers[headerName] = headerValue;
    }
  });
  return headers;
};

export { xhrGetHeaders };
//# sourceMappingURL=xhrGetHeaders.js.map
